<template>
  <div class="gateway-administration">
    <div class="flex_space_between search_box">
      <div
        class="xw_btn active"
      >
        {{ zone_name || "" }}
      </div>
      <div class="sx_btn flex_center_center" @click="reset()">
        <img src="../../../src/assets/refresh.png" alt="" class="icon_btn refresh-icon"  :class="{ rotate: isRotating }"/>
        <span>刷新</span>
      </div>
      <div class="add_btn flex_center_center" @click="addMac">
        <img src="../../../src/assets/addicon.png" alt="" class="icon_btn" />
        <span>新增网关</span>
      </div>
    </div>
    <el-table
      :data="tableData"
      v-loading="loading"
      align="center"
      border
      max-height="600"
    >
      <el-table-column prop="index" label="序号" align="center">
      </el-table-column>
      <el-table-column
        prop="mac"
        label="MAC地址"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="last_time"
        label="最后在线时间"
        align="center"
      ></el-table-column>
      <el-table-column prop="name" label="操作" align="center">
        <template slot-scope="scope">
          <div class="flex_center_center">
            <div class="white_btn" @click="openlist_dialog(scope.row)">
              查看白名单
            </div>
            <div class="delete_btn" @click="opendelMac(scope.row)">
              删除
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 15, 20, 25]"
        :page-size="perPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog
      :visible.sync="add_dialog"
      title="新增网关"
      width="620px"
      top="25vh"
      :show-close="false"
    >
      <div class="dialog-body_add">
        <div class="add_dialog_content">
          <div class="add_title">
            所属病区：{{ zone_name || "" }}
          </div>

          <div class="mac_title">
            网关MAC地址：
          </div>
          <macInput v-model="code" :segments="6" :segmentLength="2" />
        </div>

        <div class="dialog-body_footer">
          <el-button type="info" @click="add_dialog = false" size="medium"
            >取消</el-button>
          <el-button type="primary" @click="addMacFn()" size="medium"
            >确定</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="del_dialog"
      title="删除网关"
      width="580px"
      top="25vh"
      :show-close="false"
    >
      <div class="dialog-body_add">
        <div class="dialog-body_del">
          是否删除?
        </div>

        <div class="dialog-body_footer">
          <el-button type="info" @click="del_dialog = false" size="medium"
            >取消</el-button
          >
          <el-button type="primary" @click="delMac()" size="medium"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="list_dialog"
      title="白名单列表"
      width="826px"
      top="25vh"
    >
      <div class="dialog-body_list">
        <div class="mac_list">
          网关MAC：{{  curmac || ""  }}
        </div>
        <div class="max_cur">
          当前设备白名单：
        </div>

        <div class="tablebox">
          <el-table :data="whitelist" v-loading="whiteLoading" align="center" border>
            <el-table-column prop="index" label="序号" align="center">
                <template slot-scope="scope">
                  <div>
                     {{ scope.$index + 1 > 9 ? scope.$index + 1 : "0" + (scope.$index + 1) }}
                  </div>
                </template>
            </el-table-column>
            <el-table-column
              prop="ccid"
              label="CCID"
              align="center"
              width="528"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>

    <cusTomDialog ref="cusTomDialog" title="网关管理" width="580px">
      <div class="dialog-body">
        <div class="tip">请输入管理员密码，获取该功能权限</div>
        <password-input
          v-model="password"
          :length="6"
          @success="passwordCheck"
        />
      </div>
    </cusTomDialog>
  </div>
</template>
<script>
import cusTomDialog from "../../../src/view/managePages/components/custom-dialog.vue";
import passwordInput from "../../../src/view/managePages/components/passwordInput.vue";
import macInput from "../../../src/view/managePages/components/macInput.vue";
import { Loading } from "element-ui";
export default {
  components: {
    cusTomDialog,
    passwordInput,
    macInput
  },
  data() {
    return {
      isRotating:false,
      list_dialog: false,
      code: "",
      del_dialog: false,
      add_dialog: false, // 新增网关弹窗
      whitelist:[],
      searchForm: {
        ccid: "",
        bed_number: "",
        patient_id: ""
      },
      page: 1,
      perPage: 10,
      total: 0,
      tableData: [],
      loading: false,
      zone_number: "",
      password: "",
      del_id: "",
      curmac:"",
      whiteLoading: false,
      zone_name:""
    }
  },
  mounted() {
    this.$refs.cusTomDialog.open("gateway-administration");
    if (!this.$cookies.get("token")) {
      this.$router.push("/login");
    }
    this.zone_number = this.$cookies.get("zone_number");
     this.zone_name = this.$cookies.get("zone_name");
    this.fetchData();
  },
  methods: {
    // 查看白名单http://mirrors.aliyun.com/centos/8-stream/x86_64/os/repodata/?spm=a2c6h.25603864.0.0.4f4855df0Tefep
    openlist_dialog(row){
        this.curmac = row.mac || "";
          this.list_dialog = true;
        this.whiteLoading = true;
           this.$http({
        url: "/api/gateway/whitelist",
        method: "GET",
        params: {
          zone_number:this.zone_number,
          gateway_mac:row.mac
        },
        headers: {
          Token: this.$cookies.get("token")
        }
      }).then(res => {
           this.whitelist = res.result || [];
      }).finally(err => {
            this.whiteLoading = false;
               
      });
    },
    opendelMac(row) {
      this.del_id = row.id;
      this.del_dialog = true;
    },
    delMac() {
      let loadingInstance = Loading.service({
        text: "正在删除...",
        target: ".dialog-body_del"
      });
      let data = {
         zone_number: this.zone_number,
        id:  this.del_id
      };
       this.$http({
        url: "/api/gateway/del",
        method: "POST",
        data: data,
        headers: {
          Token: this.$cookies.get("token")
        }
      }).then(res => {
      this.del_dialog = false;
        this.$message.success("删除网关成功");
      this.fetchData();
      loadingInstance.close();
      }).finally(err => {
            loadingInstance.close();
      });
    },
    // 新增网关
    addMacFn() {
      let code = this.code;
      let codeFlag = this.code.split(":").every(item => item !== "" && item.length === 2);
      if (!this.code || !codeFlag) {
        return this.$message.error("每格至少两个字符,请补全网关MAC地址");
      }
      let loadingInstance = Loading.service({
        text: "正在添加...", 
        target: ".dialog-body_add"
      });
      let data = {
        zone_number: this.zone_number,
        mac: code
      };
       this.$http({
        url: "/api/gateway/add",
        method: "POST",
        data: data,
        headers: {
          Token: this.$cookies.get("token")
        }
      }).then(res => {
      this.add_dialog = false;
      this.$message.success("新增网关成功");
       this.fetchData();
      loadingInstance.close();
      }).finally(err => {
             loadingInstance.close();
      });
    },
    addMac() {
      this.code = "";
      this.add_dialog = true;
    },
    // 密码验证
   async passwordCheck(e) {
      let loadingInstance = Loading.service({
        text: "正在验证密码...",
        target: ".dialog-body"
      });

      try {
           await this.$http({
              url: "/api/zone/codeVerify",
              method: "POST",
              params: {
                zone_number: this.$cookies.get("zone_number"),
                code: e,
                code_type:"CODE_GATEWAY"
              },
              headers: {
                Token: this.$cookies.get("token")
              }
            });
             this.$refs.cusTomDialog.close();
      } catch (error) {
          this.password = ",,,,,";
        loadingInstance.close();
      }
    },
    reset() {
       this.isRotating = false 
        // 重绘，确保能重复动画
        requestAnimationFrame(() => {
          this.isRotating = true
        })
      this.page = 1;
      this.fetchData();
    },
    handleSizeChange(e) {
      this.perPage = e;
      this.page = 1;
      this.fetchData();
    },
    handleCurrentChange(e) {
      this.page = e;
      this.fetchData();
    },
    fetchData() {
      this.loading = true;
      let data = {
        page: this.page,
        perPage: this.perPage,
        zone_number: this.zone_number
      };
      this.$http({
        url: "/api/gateway/list",
        method: "GET",
        params: data,
        headers: {
          Token: this.$cookies.get("token")
        }
      }).then(res => {
        const result = res.result.data || [];
        this.tableData = result;
        let start =  (this.page-1)*this.perPage+1;
        this.tableData.forEach((item, idx) => {
           item.index = start + idx > 9 ? start + idx : "0" + (start + idx);
        });
        this.total = res.result.total;
        this.loading = false;
      });
    },
    showAuthDialog() {
      this.authDialogVisible = true;
    }
  }
};
</script>
<style scoped>
.gateway-administration {
  height: 100%;
  padding: 24px;
  background-color: #f5f7fb;
}
.mac_list {
  font-weight: 400;
  font-size: 12px;
  color: #636676;
  margin-bottom: 24px;
}
.max_cur {
  font-weight: 400;
  font-size: 12px;
  color: #636676;
  margin-bottom: 12px;
}
.tablebox {
  height: 342px;
  overflow-y: auto;
  padding-right: 14px;
}
.tip {
  height: 16px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #252b50;
  line-height: 16px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  margin-top: 120px;
  margin-bottom: 24px;
}
@keyframes rotate360 {
  100% { transform: rotate(360deg) }
}
.refresh-icon.rotate {
  animation: rotate360 0.6s linear;
}
>>> .el-dialog__body {
  padding: 0 !important;
}
.dialog-body_list {
  padding: 24px;
}
.xw_btn {
  width: fit-content;
  height: 38px;
  padding: 0 20px;

  border-radius: 8px 8px 8px 8px;
  font-weight: bold;
  font-size: 14px;
  user-select: none;
  text-align: center;
  line-height: 38px;
  margin-right: auto;
  cursor: pointer;
  background: #fff;
  color: #3889ff;
  border: 1px solid #3889ff !important;
}
.active {
  background: #3889ff !important;
  color: #ffffff !important;
  border: 1px solid #3889ff !important;
}
.sx_btn {
  width: 86px;
  height: 38px;
  background: #929faf;
  border-radius: 8px 8px 8px 8px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  line-height: 38px;
  user-select: none;
  cursor: pointer;
}
.add_btn {
  width: 116px;
  height: 38px;
  background: #3889ff;
  border-radius: 8px 8px 8px 8px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  line-height: 38px;
  margin-left: 12px;
  user-select: none;
  cursor: pointer;
}
.dialog-body_del {
  margin: 64px 0;
  font-weight: 400;
  font-size: 16px;
  color: #636676;
  text-align: center;
}
.white_btn {
  width: 97px;
  height: 30px;
  background: #e8eeff;
  border-radius: 8px 8px 8px 8px;
  font-weight: 400;
  font-size: 14px;
  color: #3889ff;
  text-align: center;
  line-height: 30px;
  margin-right: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;
}
.add_btn:hover {
  opacity: 0.8;
}
.white_btn:active {
  background-color: #3889ff;
}
.delete_btn:active {
  background-color: rgba(226, 64, 64, 0.4);
}
.icon_btn {
  width: 24px;
  height: 24px;
  margin-right: 4px;
}
.delete_btn {
  width: 53px;
  height: 30px;
  background: #fdf0f0;
  border-radius: 8px 8px 8px 8px;
  font-weight: 400;
  font-size: 14px;
  color: #e24040;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
  user-select: none;
}

.add_dialog_content {
  margin: 24px;
}
.dialog-body_footer {
  padding: 24px 0;
  border-top: 1px solid #eeeeee;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 46px;
}
>>> .dialog-body_footer .el-button {
  width: 81px;
  height: 32px;
  border-radius: 8px 8px 8px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
}
>>> .el-button--info {
  background-color: #9296af;
}
>>> .el-button--primary {
  background-color: #3889ff;
}
.add_title {
  width: fit-content;
  padding: 0 20px;
  height: 38px;
  background: #3889ff;
  border-radius: 8px 8px 8px 8px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  line-height: 38px;
  margin-bottom: 60px;
}
.mac_title {
  font-weight: 400;
  font-size: 16px;
  color: #252b50;
  margin-bottom: 24px;
}

/* 滚动条整体宽度 */
::-webkit-scrollbar {
  width: 8px; /* 可根据需要调整宽度 */
  background: #e6f0ff;
  margin-left: 10px;
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: #e6f0ff;
  border-radius: 8px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: #929faf;
  border-radius: 4px;
  min-height: 60px;
  transition: background 0.2s;
}

/* 鼠标悬停时滑块颜色 */
::-webkit-scrollbar-thumb:hover {
  background: #6c8199;
}

/* 横向滚动条（如有） */
::-webkit-scrollbar-horizontal {
  height: 12px;
}
.transition{
  transition: all 0.5s linear;
}
</style>



// WEBPACK FOOTER //
// src/view/managePages/gateway_administration.vue